import AddBoxIcon from '@mui/icons-material/AddBox';
import WorkIcon from '@mui/icons-material/Work';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Guid from 'common/values/guid/guid';
import Name from 'common/values/name/name';
import * as React from 'react';
import SelectedRepresentative from 'work/values/selected-representative/selected-representative';
import SelectedVendorTeam from 'work/values/selected-vendor-team/selected-vendor-team';

const StyledButton = styled(Button)(({ theme }) => ({
  [theme.breakpoints.down('sm')]: {
    width: '100%'
  },
  marginBottom: theme.spacing(1),
  marginLeft: theme.spacing(2),
  minWidth: theme.spacing(30)
}));

export type DirectProposalButtonProps = {
  action: "create" | "request";
  targetTeamId?: Guid;
  targetUserId?: Guid;
  targetEntityId?: Guid;
  targetName?: Name;
  targetIsVendorRep?: boolean;
  targetIsClientRep?: boolean;
  useStyledButton?: boolean;
  targetTeamName?: string;
  onClick: (targetUrl: URL) => void;
};

export default function DirectProposalButton(props: Readonly<DirectProposalButtonProps>) {
  const {
    action,
    targetTeamId,
    targetUserId,
    targetEntityId,
    targetName,
    useStyledButton,
    targetTeamName,
    onClick
  } = props;

  const targetIsVendorRep = props.targetIsVendorRep ?? false;
  const targetIsClientRep = props.targetIsClientRep ?? false

  const handleClick = () => {
    if (targetTeamId) {
      const team = new SelectedVendorTeam(targetTeamId, targetTeamName);
      const result = team.generateTargetUrl(action, globalThis.location);
      onClick(result);
    } else if (targetUserId) {
      if (!targetIsClientRep && !targetIsVendorRep) return;
      const rep = new SelectedRepresentative(targetUserId, targetEntityId!, targetIsClientRep, targetIsVendorRep, targetName!);
      const result = rep.generateTargetUrl(action, globalThis.location);
      onClick(result);
    }
  };

  return (
    <>
      {useStyledButton &&
        <StyledButton
          variant="outlined"
          startIcon={action === "create" ? <AddBoxIcon /> : <WorkIcon />}
          onClick={handleClick}>
          {action === "create" ? "Create Proposal" : "Request Proposal"}
        </StyledButton>
      }
      {!useStyledButton &&
        <Button
          color="primary"
          startIcon={action === "create" ? <AddBoxIcon /> : <WorkIcon />}
          onClick={handleClick}>
          {action === "create" ? "Create Proposal" : "Request Proposal"}
        </Button>
      }
    </>
  );
}
